import React, { useCallback } from 'react';
import { Link } from 'react-router-dom';

import {
  ReactComponent as ArrowRight,
} from '../../assets/arrow-right-to-paint.svg';

import styles from './ViewMoreButton.module.css';

const ViewMoreButton = ({
  className = '',
  disabled = false,
  isLink = false,
  onClick = () => { },
  text = '',
  to = '',
}) => {
  const Wrapper = useCallback(({ children }) => {
    if (isLink) {
      return (
        <Link className={`${styles.viewMoreButton} ${className}`} to={to}>
          {children}
        </Link>
      );
    }

    return (
      <button
        className={`${styles.viewMoreButton} ${className}`}
        disabled={disabled}
        onClick={onClick}
        type="button"
      >
        {children}
      </button>
    );
  }, [isLink, onClick, to, disabled, className]);

  return (
    <Wrapper>
      <span>{text}</span>

      <ArrowRight className="Branded-icon" />
    </Wrapper>
  );
};

export { ViewMoreButton };
